const pad = (value) => String(value).padStart(2, '0');

export function formatCountdown(ms) {
  const total = Math.max(0, Math.floor(ms / 1000));
  const days = Math.floor(total / 86400);
  const hours = Math.floor((total % 86400) / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  if (days > 0) return `${days}d ${hours}h ${pad(minutes)}m`;
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

export function formatDuration(minutes) {
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (hours === 0) return `${rest} min`;
  return rest === 0 ? `${hours} hr` : `${hours} hr ${rest} min`;
}

export function formatElapsed(seconds) {
  const total = Math.max(0, Math.floor(seconds));
  return `${Math.floor(total / 3600)}:${pad(Math.floor((total % 3600) / 60))}:${pad(total % 60)}`;
}

const dateTimeFormat = new Intl.DateTimeFormat(undefined, {
  weekday: 'short',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
});
const dateFormat = new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
const shortDateFormat = new Intl.DateTimeFormat(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
const dayUtcFormat = new Intl.DateTimeFormat(undefined, { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' });
const timeFormat = new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' });
const monthFormat = new Intl.DateTimeFormat(undefined, { month: 'short' });
const monthYearFormat = new Intl.DateTimeFormat(undefined, { month: 'long', year: 'numeric' });
const relativeFormat = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });

export const formatDateTime = (value) => dateTimeFormat.format(new Date(value));
export const formatDate = (value) => dateFormat.format(new Date(value));
export const formatShortDate = (value) => shortDateFormat.format(new Date(value));
export const formatDayUtc = (isoDate) => dayUtcFormat.format(new Date(`${isoDate}T00:00:00Z`));
export const formatTime = (value) => timeFormat.format(new Date(value));
export const formatMonth = (value) => monthFormat.format(new Date(value));
export const formatMonthYear = (value) => monthYearFormat.format(new Date(value));

export function formatRelative(value, nowMs = Date.now()) {
  const seconds = Math.round((new Date(value).getTime() - nowMs) / 1000);
  const abs = Math.abs(seconds);
  if (abs < 45) return relativeFormat.format(0, 'second');
  if (abs < 3600) return relativeFormat.format(Math.round(seconds / 60), 'minute');
  if (abs < 86400) return relativeFormat.format(Math.round(seconds / 3600), 'hour');
  if (abs < 86400 * 30) return relativeFormat.format(Math.round(seconds / 86400), 'day');
  return formatDate(value);
}

export function acceptanceRate(accepted, submissions) {
  if (!submissions) return null;
  return Math.round((accepted / submissions) * 100);
}

export function formatMemory(kilobytes) {
  if (kilobytes === null || kilobytes === undefined) return null;
  return (kilobytes / 1024).toFixed(1);
}
